module.exports = __webpack_public_path__ + "img/whatsapp.8671d88f.svg";